
<div class="ui-g">
    <div class="ui-sm-12 ui-md-12 ui-lg-10 ui-xl-8">
        <p-panel header="{{ 'email_address' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
            <form *ngIf="!showCodeModal" [formGroup]="changeEmailForm" (ngSubmit)="onSubmit()" style="padding-top: 10px;">
              <span class="ui-float-label">
                  <input id="email-input" name="email" type="email" pInputText style="width: 100%;" formControlName="new_email">
                  <label for="email-input">{{ 'email_address' | translate }}</label>
              </span>
              <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3" style="padding-left: 0; margin-top: 10px;">
                <button pButton type="submit" label="{{ 'change_email' | translate }}" [disabled]="!changeEmailForm.valid || isLoading" class="ui-button-info"></button>
              </div>
            </form>

            <div *ngIf="showCodeModal" style="padding-top: 10px;">
              <span class="ui-float-label">
                <input id="code-input" [(ngModel)]="code" type="text" pInputText style="width: 100%;">
                <label for="code-input">{{ 'enter_code_from_email' | translate }}</label>
              </span>
              <span *ngIf="codeError" class="errorMessage" style="display: block; margin-bottom: 10px;">{{ 'invalid_code' | translate }}</span>
              <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3" style="padding-left: 0; margin-top: 10px;">
                <button pButton type="button" label="{{ 'submit' | translate }}" [disabled]="isLoading || (code.length < 6)" (click)="verifyCode()" class="ui-button-info"></button>
              </div>
            </div>

            <app-loader *ngIf="isLoading"></app-loader>

        </p-panel>
    </div>
</div>


